import { render } from "./ProjectSection.vue?vue&type=template&id=1578dd58&scoped=true"
const script = {}

import "./ProjectSection.vue?vue&type=style&index=0&id=1578dd58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1578dd58"]])

export default __exports__